export default {
  layoutType: (state) => state.layoutType,
  toggleMenu: (state) => state.toggleMenu,
  mapStyle: (state) => state.mapStyle,
  isMap: (state) => state.isMap, 
}
